import { IAuthState } from '../redux/AuthRedux';
import { ADMIN_GROUPS, MERCHANT_GROUPS } from '../views/login/Login';

// TODO check partners permissions
// Everywhere check PARTNER_ADMIN and INTEGRATION_PARTNER_ADMIN
// Rename claims

export enum CLAIMS {
	SUPER_ADMIN = 'SUPER_ADMIN',
	MERCHANT_ADMIN = 'MERCHANT_ADMIN',
	PARTNER_ADMIN = 'PARTNER_ADMIN',
	INTEGRATION_PARTNER_ADMIN = 'INTEGRATION_PARTNER_ADMIN',
	MERCHANT_SUPPORT = 'MERCHANT_SUPPORT',
	MERCHANT_SUPPORT_ADMIN = 'MERCHANT_SUPPORT_ADMIN',
	MERCHANT_FINANCE = 'MERCHANT_FINANCE',
	MERCHANT_DEVELOPER = 'MERCHANT_DEVELOPER',
	SUPER_ADMIN_AND_MERCHANT_ADMIN = 'SUPER_ADMIN_AND_MERCHANT_ADMIN',
	SUPER_ADMIN_AND_PARTNER_ADMIN = 'SUPER_ADMIN_AND_PARTNER_ADMIN',
	SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN = 'SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN',
	SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_FINANCE = 'SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_FINANCE',
	SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN = 'SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN',
	SUPER_ADMIN_AND_ALL_MERCHANTS_AND_PARTNER_ADMIN = 'SUPER_ADMIN_AND_ALL_MERCHANTS_AND_PARTNER_ADMIN',
	SUPER_ADMIN_AND_ALL_MERCHANTS = 'SUPER_ADMIN_AND_ALL_MERCHANTS',
	PARTNER_ADMIN_AND_INTEGRATION_PARTNER_ADMIN = 'PARTNER_ADMIN_AND_INTEGRATION_PARTNER_ADMIN',
	MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN = 'MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN',
	MERCHANT_ADMIN_AND_MERCHANT_FINANCE = 'MERCHANT_ADMIN_AND_MERCHANT_FINANCE',
	MERCHANT_ADMIN_AND_PARTNER_ADMIN = 'MERCHANT_ADMIN_AND_PARTNER_ADMIN',
	SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN = 'SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN',
	SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN_AND_MERCHANT_SUPPORT_ADMIN = 'SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN_AND_MERCHANT_SUPPORT_ADMIN',
	ALL_ROLES = 'ALL_ROLES',
	ALL_MERCHANT_DEVELOPERS_ROLES = 'ALL_MERCHANT_DEVELOPERS_ROLES',
}

export const checkRoles = (authUser: IAuthState, claims: CLAIMS ): boolean => {
	switch (claims) {
		case CLAIMS.SUPER_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN);
		case CLAIMS.MERCHANT_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.MERCHANT_ADMIN);
		case CLAIMS.PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.PARTNER_ADMIN);
		case CLAIMS.INTEGRATION_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN);
		case CLAIMS.MERCHANT_SUPPORT:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_SUPPORT);
		case CLAIMS.MERCHANT_SUPPORT_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN);
		case CLAIMS.MERCHANT_FINANCE:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_FINANCE);
		case CLAIMS.MERCHANT_DEVELOPER:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_DEVELOPER);
		case CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.MERCHANT_ADMIN);
		case CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN ||
				el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN);

		case CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN);

		case CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_FINANCE:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.MERCHANT_ADMIN ||
				el === MERCHANT_GROUPS.MERCHANT_FINANCE);
		case CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.MERCHANT_ADMIN ||
				el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN);
		case CLAIMS.SUPER_ADMIN_AND_ALL_MERCHANTS_AND_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN ||
				el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN ||
				el === MERCHANT_GROUPS.MERCHANT_SUPPORT ||
				el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN ||
				el === MERCHANT_GROUPS.MERCHANT_FINANCE ||
				el === MERCHANT_GROUPS.MERCHANT_DEVELOPER
			);
		case CLAIMS.SUPER_ADMIN_AND_ALL_MERCHANTS:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_FINANCE
				|| el === MERCHANT_GROUPS.MERCHANT_DEVELOPER
			);
		case CLAIMS.PARTNER_ADMIN_AND_INTEGRATION_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN
				|| el === ADMIN_GROUPS.PARTNER_ADMIN
				|| el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN
			);
		case CLAIMS.MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN || el === ADMIN_GROUPS.MERCHANT_ADMIN);
		case CLAIMS.MERCHANT_ADMIN_AND_MERCHANT_FINANCE:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN || el === MERCHANT_GROUPS.MERCHANT_FINANCE);
			case CLAIMS.MERCHANT_ADMIN_AND_PARTNER_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === ADMIN_GROUPS.MERCHANT_ADMIN ||
				el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN);
		case CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_SUPPORT_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN ||
				el === ADMIN_GROUPS.MERCHANT_ADMIN ||
				el === ADMIN_GROUPS.SUPER_ADMIN);
			case CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN_AND_MERCHANT_SUPPORT_ADMIN:
			return authUser?.userData?.userGroups?.some(el =>
				el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN ||
				el === ADMIN_GROUPS.MERCHANT_ADMIN ||
				el === ADMIN_GROUPS.SUPER_ADMIN ||
				el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN ||
				el === ADMIN_GROUPS.PARTNER_ADMIN);
		case CLAIMS.ALL_ROLES:
			return authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN
				|| el === ADMIN_GROUPS.PARTNER_ADMIN
				|| el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN
				|| el === ADMIN_GROUPS.MERCHANT_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_FINANCE
				|| el === MERCHANT_GROUPS.MERCHANT_DEVELOPER
			);
			case CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES:
			return authUser?.userData?.userGroups?.some(el => el === MERCHANT_GROUPS.MERCHANT_DEVELOPER
				|| el === ADMIN_GROUPS.MERCHANT_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT
				|| el === MERCHANT_GROUPS.MERCHANT_SUPPORT_ADMIN
				|| el === MERCHANT_GROUPS.MERCHANT_FINANCE
			);
		default: return false;
	}
};
